import { render, staticRenderFns } from "./MenuManager.vue?vue&type=template&id=094dfe88&scoped=true&"
import script from "./MenuManager.vue?vue&type=script&lang=js&"
export * from "./MenuManager.vue?vue&type=script&lang=js&"
import style0 from "./MenuManager.vue?vue&type=style&index=0&id=094dfe88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094dfe88",
  null
  
)

export default component.exports